import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient, HttpContext } from '@angular/common/http';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { SKIP_LOADER } from '../tokens/skip-loader.token';

@Injectable({
  providedIn: 'root'
})
export class WebService {
  constructor(private http: HttpClient, private dialog: MatDialog) { }

  private url = environment.WS_URL + '/api/v1/'
  //faster option. Will see data in the url. Use for less security and smaller files
  //params/headers should be an array of objects using the param/header name as "name" and param/header value as "value"
  public getWebCall(fileName: string, method: string, options?: { params?: { name: string, value: any }[],headers?: { name: string, value: any }[], body?: any, responseType?: 'json' | 'blob' | 'text', skipLoader?: boolean}): Observable<any> {
    let params: HttpParams = new HttpParams();
    let headers: HttpHeaders = new HttpHeaders();
    let webOptions: any = { headers };

    // ✅ Process Query Params (for GET requests)
    if (options?.params) {
      options.params.forEach((p) => {
        params = params.append(p.name, p.value);
      });
      webOptions.params = params;
    }

    // ✅ Process Headers
    if (options?.headers) {
      options.headers.forEach((h) => {
        headers = headers.set(h.name, h.value);
      });
      webOptions.headers = headers;
    }

    if (options?.responseType) {
      webOptions.responseType = options.responseType;
    }

    if (options?.skipLoader === true) {
      webOptions.context = new HttpContext().set(SKIP_LOADER, true);
    }

    // ✅ Automatically Choose GET or POST
    if (options?.body) {
      try {
        return this.http.post(`${this.url}${fileName}/${method}`, options.body, webOptions);
      } catch (error) {
        console.error('HTTP POST Error:', error);
        throw error;
      }
    } else {
      return this.http.get(`${this.url}${fileName}/${method}`, webOptions);
    }
  }

}
